import { AppendixGenerate as Component } from './component';
import { Connector } from './connector';
import { ConnectorAppendixGenerateProps } from '../Appendix.proptype';

export interface AppendixGenerateProps extends Omit<ConnectorAppendixGenerateProps, 'component'> {}

export const AppendixGenerate = (props: AppendixGenerateProps) => <Connector {...props} component={Component} />;
